<template>
	<div>
		<el-card class="box-card" shadow="hover" v-if="setlist.length>0">
			<div slot="header" class="clearfix">
				<span>{{title }}</span>
			</div>
			<div class="inputBox" v-if="!isdetail">
				<el-form-item
					v-if="i.ishidden == 'False'"
					:class="['inputItem', i.controltype == 'textarea'? 'col20' : 'col8']"
					:label="i.showname"
					label-width="100px"
					v-for="(i, index) in setlist"
					:key="index"
					size="mini"
				>
					<el-input
						v-if="i.controltype == 'text' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:type="i.controltype"
						v-model="i.value"
						:ref="i.colname"
						@keyup.native="val => enterinput(val, i)"
					></el-input>
					<el-input
						v-if="i.controltype == 'text_change' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						type="text"
						v-model="i.value"
						:ref="i.colname"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
						@change.native="val => text_change(val, i)"
					></el-input>
					<el-autocomplete
						:ref="i.colname"
						v-if="i.controltype == 'input_filter'"
						v-model="i.value"
						:fetch-suggestions="
							(queryString, cb) => {
								inputsuggestions(queryString, cb, i);
							}
						"
						:style="{ width: `${i.coltdwidth}px` }"
						value-key="showname"
						:trigger-on-focus="true"
						@keyup.native="val => enterinput(val, i)"
						@change.native="val => text_change(val, i)"
					></el-autocomplete>
					
					<el-input
						:ref="i.colname"
						v-if="i.controltype == 'text_group' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						:type="i.controltype"
						v-model="i.value"
						class="input-with-search"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
						@change.native="val => text_change(val, i)"
					>
						<div slot="append" v-if="i.colass == 'search'" @click="inputgroupsearch(i, index)">
							<span style="padding:15px"><i class="el-icon-search"></i></span>
						</div>
					</el-input>
			
					<el-input
						:ref="i.colname"
						v-if="i.controltype == 'textarea' && i.ishidden == 'False'"
						:type="i.controltype"
						v-model="i.value"
						@keyup.native="val => enterinput(val, i)"
					></el-input>
					<el-select
						:ref="i.colname"
						v-model="i.value"
						filterable
						clearable
						reserve-keyword
						placeholder="可输入关键词搜索"
						:loading="loading"
						v-if="i.controltype == 'select_filter' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						@change.native="val => text_change(val, i)"
						@keyup.native="val => enterinput(val, i)"
					>
						<el-option disabled label="可输入关键词搜索" value=""></el-option>
						<el-option v-for="item in i.colsource" :key="item.value" :label="item.title" :value="item.value"></el-option>
					</el-select>
					<el-select
					  v-model="i.value" size="mini"
					  v-if="i.controltype == 'select_multiple' && i.ishidden == 'False'" 
					   multiple
					   filterable
					   :style="{ width: `${i.coltdwidth}px` }"
					   placeholder="">
					 <el-option v-for="item in i.colsource" :key="item.u_account" :label="item.u_account" :value="item.u_account"></el-option>
					 </el-select>
					<el-select
						:ref="i.colname"
						v-model="i.value"
						filterable 
						v-if="i.controltype == 'select' && i.ishidden == 'False'"
						:style="{ width: `${i.coltdwidth}px` }"
						@keyup.native="val => enterinput(val, i)"
					>
						<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
					</el-select>
					<el-checkbox
						v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
						:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
						:checked="i.coldefault == 1 ? true : false"
						@change="val => setcheck(val, i)"
					></el-checkbox>
			
					<el-radio v-else-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
				</el-form-item>
			</div>
			<div class="inputBox" v-if="isdetail">
				<el-form-item
					v-if="i.ishidden == 'False'"
					:class="['inputItem', i.controltype == 'textarea'? 'col24' : 'col8']"
					:label="i.showname"
					label-width="110px"
					v-for="(i, index) in setlist"
					:key="index"
					size="mini"
				>
				<span v-if="i.controltype != 'textarea'">{{i.value}}</span>
				<div v-else>{{i.value}}</div>
				</el-form-item>
			</div>
		</el-card>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {
		classname: {
			type: String,
			default:''
		},
		title:{
			type: String,
			default:''
		},
		l_mode:{
			type: String,
			default:''
		},
		isdetail:{
			type:Boolean,
			isdetail:false
		}
	},
	data() {
		return {
			setlist: [],
			customerinfo: {},
			syscol:''
		};
	},
	mounted() {

	},
	methods: {
		init(param){
			if(param.syscol!=undefined)
				this.syscol=param.syscol;
			if(param.customerinfo!=undefined){
				this.customerinfo=param.customerinfo;
			}
			this.setlist=[];
			this.getsetlist();
		},
		getsetlist(){
			var that=this;
			//debugger
			this.$apipost.get.GetPagecolSet({syscol:this.syscol,l_mode:this.l_mode}).then(res => {
				if(res.length>0){
					if(that.setlist.length>0)
						that.setlist=that.setlist.concat(res);
					else
						that.setlist=res;

					if(that.customerinfo.id!=undefined){
						that.setlist.forEach(item => {
							for(var i in that.customerinfo){
								if(i==item.colname){
									item.value=that.customerinfo[i];
								}
							}
						});
					}
				}
			});
		},
		enterinput(event, i) {
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') {
						if(this.$refs[i.colnext]!=undefined)
								this.$refs[i.colnext][0].focus();
					}
				} else if (event.keyCode == 37) {
					if (i.colperv != ''){
						 if(this.$refs[i.colperv]!=undefined)
							this.$refs[i.colperv][0].focus();
					}
				}
			}
		},
		//文本框输入时自动提示
		inputsuggestions(querystring, cb, i, modelindex) {
			if (i.colevent != '') {
				this.$tool.inputsuggestions_call(this, modelindex, i, cb);
			}
		},
		//文本框改变
		text_change(val, i) {
			if (i.colevent != '') {
				this.$tool.addrlink_model(this, val, i);
			} else {
				
				//debugger;
			}
		},
		checkinput(event, i) {
			if (i.colname == 'ctphone' || i.colname == 'cgphone') {
				if (i.value != '') {
					if (i.coltype == 'phone_10') {
						if (i.value.length < 10) {
							this.$tool.message(i.showname + '不能少于10位', 0);
							this.$refs[i.colname][0].focus();
						}
					}
				}
			}
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
	}
};
</script>